import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box, Dialog, DialogContent, DialogTitle, TextareaAutosize, styled } from '@mui/material';
import { StyledButton } from 'app/components';
import { Colors, DarkmodeColors } from 'app/constants/color';
import apiService from 'app/services/apiService';

const FormContainer = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '20px',
  marginTop: '20px',
});

export default function CreatePolicy({ isOpen, setIsOpen, setShowToast }) {
  const { darkmode } = useSelector(state => state.dark);
  const withoutTemplate = useSelector(state => state.privacyPersisted.WithoutTemplate);
  const { t } = useTranslation('translation', { keyPrefix: 'policy_manager' });
  const [message, setMessage] = useState('');

  const handleClose = () => {
    setIsOpen({ ...isOpen, requestDatatype: false });
  };

  const handleRequestDatatype = async () => {
    try {
      await apiService.requestDataType({
        policyTypeId: withoutTemplate.policyType,
        message,
      });
      handleClose();
      setShowToast({
        open: true,
        message: 'Requested successfully',
        severity: 'success',
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleChange = e => {
    setMessage(e.target.value);
  };
  return (
    <>
      <Dialog open={true} onClose={handleClose}>
        <Box
          sx={{
            background: darkmode && '#17223b',
            width: '600px',
            paddingBottom: '10px',
            minHeight: '25vh',
          }}
        >
          <DialogTitle sx={{ color: darkmode && Colors.primary, textAlign: 'center' }}>
            {t('request_datatype')}
          </DialogTitle>

          <DialogContent>
            <FormContainer noValidate autoComplete='off'>
              <TextareaAutosize
                noValidate
                id='name'
                // value={data?.name}
                name='name'
                onChange={handleChange}
                minRows={8}
                maxRows={8}
                style={{
                  fontSize: '1rem',
                  resize: 'none',
                  width: '100%',
                  backgroundColor: darkmode && 'transparent',
                  borderColor: darkmode && DarkmodeColors.menuIcon,
                  marginRight: '10px',
                  color: darkmode ? Colors.lightText : Colors.secondary,

                  '&:hover': {
                    borderColor: darkmode && DarkmodeColors.menuIcon,
                  },
                  '&:focus': {
                    outline: 'none',
                    borderColor: darkmode ? Colors.primary : 'inherit',
                  },
                  '&:focus + label': {
                    color: darkmode ? Colors.primary : 'inherit',
                    transform: 'translate(15px, -16px)',
                    fontSize: '0.75rem',
                  },
                }}
              />

              <StyledButton disabled={!message} name='Save' onClick={handleRequestDatatype}>
                {t('request')}
              </StyledButton>
            </FormContainer>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
}
